import IRepresentativeRepository from 'domain/interfaces/repositories/IRepresentativeRepository'
import { UpdateRoleRepresentativeCommandRequest } from 'domain/entities/representative'

export const updateRoleRepresentativeCommand = (
  repository: IRepresentativeRepository,
  promotionId: string,
  representativeId: string,
  data: UpdateRoleRepresentativeCommandRequest,
) => {
  return repository.updateRole(promotionId, representativeId, data)
}
